import React, { useState, useEffect, useContext, useMemo } from 'react';
import { Grid, Typography, Paper } from '@mui/material';
import DashboardTopMenu from './DashboardTopMenu';
import { ConstantsContext } from "../index";
import SimpleCandleAutoFit from './TradingViewLikeChart';

export default function RouteAdminBacktest(props) {
  const [staticText] = useContext(ConstantsContext);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  const COIN = 'ETH';
  const INTERVAL = '1h';
  const LIMIT = 1000;

  const loginToken = useMemo(
    () => (props?.userDetails?.loggined_token || ''),
    [props?.userDetails]
  );
  const apiKey = useMemo(
    () => (staticText?.api_key || ''),
    [staticText]
  );

  const _api_get_candles_by_token_callback = (res) => {
    if (res && Number(res.status_code) === 2 && res.data && res.data.candles) {
        const list = res.data.candles[INTERVAL] || [];
        // make a copy and reverse → oldest → newest (left → right)
        const ordered = Array.isArray(list) ? list.slice().reverse() : [];
        setRows(ordered);
        setErr('');
    } else {
        setRows([]);
        setErr(res && res.msg ? String(res.msg) : 'No data');
    }
    setLoading(false);
    };


  const _api_get_candles_by_token = () => {
    const data = [
      { key: 'action',         value: 'get_candles_by_token' },
      { key: 'token',          value: COIN },
      { key: 'intervals',      value: INTERVAL },
      { key: 'limit',          value: String(LIMIT) },
    ];
    if (loginToken) data.push({ key: 'loggined_token', value: loginToken });
    if (apiKey)     data.push({ key: 'api_key',        value: apiKey });

    setLoading(true);
    setErr('');
    props._apiConnect(staticText.path_darts, data, _api_get_candles_by_token_callback);
  };

  useEffect(() => {
    if (!staticText?.path_darts) return;
    _api_get_candles_by_token();
    // re-fetch if token or key changes
  }, [staticText?.path_darts, loginToken, apiKey]);

  return (
    <Grid container spacing={2} style={{ width: '100%', margin: 0 }}>
      <DashboardTopMenu _apiLogOff={props._apiLogOff} userDetails={props.userDetails} />

      <Grid item xs={12} style={{ padding: '16px 24px' }}>
        <Paper style={{ padding: 16, backgroundColor: '#F9F9F9', border: '1px solid #ccc', margin: '24px 0' }}>
          <Typography variant="subtitle1">Backtest</Typography>
        </Paper>

        <Paper style={{ padding: 16, backgroundColor: '#0f0f0f', border: '1px solid #333' }}>
          <Typography variant="subtitle2" style={{ color: '#C8D1DA', marginBottom: 8 }}>
            BTC • 1h • last {LIMIT} candles {loading ? '(loading...)' : ''}
            {err ? ` — ${err}` : ''}
          </Typography>
        </Paper>
        <SimpleCandleAutoFit coin={COIN} interval={INTERVAL} rows={rows} paddingPct={0.08} />
      </Grid>
    </Grid>
  );
}
